import React from 'react';

export const ProgressIndicator = ({ percentage }) => (
  <div className="bkgd-color-gsLightDT" style={{ height: 4, borderRadius: 4, width: 110 }}>
    <div className="theme-group base background" style={{ height: 4, borderRadius: 4, width: `${percentage}%` }}/>
  </div>
);
